import { gql } from '@apollo/client';
import { TRANSCRIPT_FIELDS } from '../../fragments/message/transcript-fields';

export const TRANSCRIBE_AUDIO = gql`
    mutation($data: TranscribeAudioInput!) {
        transcribeAudio(data: $data) {
            __typename
            ... on Message {
                id
                title
                body
                ${TRANSCRIPT_FIELDS}
                createdAt
                updatedAt
                file {
                    url
                    thumbnail {
                        sm
                        md
                        lg
                        xl
                        original
                        compressed {
                            sm
                            md
                            lg
                            xl
                            original
                        }
                    }
                    name
                    displayName
                    type
                    format
                    size
                    mime
                }
            }
            ... on TranscribeAudioError {
                message
                code
            }
        }
    }
`;
